import React from "react";
import ReactQuill from "react-quill";
import "./quill.fettiSnow.css";
import { Box, Stack } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { FontStyle, JobClickType } from "../../constants";

const styles = {
  blueExpand: {
    ...FontStyle.headingBody,
    fontSize: "14px",
    color: "#0672cb",
    cursor: "pointer",
    // textDecoration: "underline",
    paddingTop: "10px",
    "&:hover": {
      color: "#1033CC",
    },
  },
};
const QuillDescription = ({
  jobDescription,
  shouldShowMore,
  setShowMore,
  logJobClick,
  url,
}) => {
  return (
    <>
      <Box sx={{ width: "100%", position: "relative" }}>
        <ReactQuill
          style={{
            width: "100%",
            padding: 0,
            //   overflow: "scroll",
            ...(!shouldShowMore && {
              height: "320px",
              overflow: "hidden",
            }),
            // borderRadius: Inputs.borderRadius,
          }}
          theme={"bubble"}
          readOnly
          value={jobDescription}
          modules={{
            clipboard: {
              matchVisual: false,
            },
          }}
        />
        {!shouldShowMore && (
          <Box
            sx={{
              height: "70px",
              width: "100%",
              position: "absolute",
              bottom: 0,
              background:
                "linear-gradient(rgba(255,255,255,0), rgba(255,255,255,1))",
            }}
          />
        )}
      </Box>
      {!shouldShowMore && (
        <Stack
          sx={{
            ...styles.blueExpand,
          }}
          direction="row"
          onClick={() => setShowMore(true)}>
          View More{" "}
          <KeyboardArrowDownIcon sx={{ transform: "translateY(-2px)" }} />
        </Stack>
      )}
      {shouldShowMore && url && (
        <Box
          onClick={() => {
            logJobClick({ clickType: JobClickType.viewMore });
            window.open(url, "_blank");
          }}
          sx={{
            marginTop: "-10px",
            ...styles.blueExpand,
          }}>
          <div>Apply on company website</div>
        </Box>
      )}
    </>
  );
};

export default QuillDescription;
